/* global axios */
import ApiClient from './ApiClient';

class ConversationsExportAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  export(filters = {}) {
    return axios.post(`${this.url}/export`, filters);
  }

  count(filters = {}) {
    return axios.post(`${this.url}/export_count`, filters);
  }
}

export default new ConversationsExportAPI();
